import { useLocalStorageState } from "ahooks"
import { ExportFormat, SheetLayout } from "components/BadgeBuilder/utils/sheetPresets"

const DEFAULT_DPI = 300

type PrintBadgeSettings = {
  preferredBadgeId: string
  setPreferredBadgeId: (v?: string) => void
  dpi: number
  setDpi: (v?: number) => void
  selectedExportFormat: ExportFormat
  setSelectedExportFormat: (v?: ExportFormat) => void
  customSheet: SheetLayout | null
  setCustomSheet: (v?: SheetLayout | null) => void
}

const usePrintBadgeSettings = (eventId: string): PrintBadgeSettings => {
  const [preferredBadgeId, setPreferredBadgeId] = useLocalStorageState<string>(
    `event-${eventId}-preferredBadgeId`,
    { defaultValue: "" },
  )
  const [dpi, setDpi] = useLocalStorageState<number>(
    `event-${eventId}-preferredDpi`,
    { defaultValue: DEFAULT_DPI },
  )
  const [selectedExportFormat, setSelectedExportFormat] = useLocalStorageState<ExportFormat>(
    `event-${eventId}-preferredExportFormat`,
    { defaultValue: ExportFormat.SINGLE },
  )
  const [customSheet, setCustomSheet] = useLocalStorageState<SheetLayout | null>(
    `event-${eventId}-customSheet`,
    { defaultValue: null },
  )

  return {
    preferredBadgeId: preferredBadgeId ?? "",
    setPreferredBadgeId,
    dpi: dpi ?? DEFAULT_DPI,
    setDpi,
    selectedExportFormat: selectedExportFormat ?? ExportFormat.SINGLE,
    setSelectedExportFormat,
    customSheet: customSheet ?? null,
    setCustomSheet,
  }
}

export default usePrintBadgeSettings
